import React from 'react'

const GuestLayout = ({ children }) => (
  <>
      {children}
  </>  
)

export default GuestLayout
